export enum SettingsOption {
    TIPURI_AMENZI = 'Tipuri Amenzi',
    TIPURI_TAXE_NEDEBITATE = 'Tipuri Taxe Nedebitate',
}

export enum AdminSettings {
    // CONFIGURARI = 'Configurări',
    // TYPE_IMAGE_DIMENSIONS = 'Dimensiuni Tip Imagini',
    CRONS = 'Cron-uri',
}